import { ScuolaTag } from ".";

export class Ambito {
    id!: string;
    nome!: string;
    scuole!: Array<ScuolaTag>;
}